import React from 'react';
import { motion } from 'framer-motion';
import {
    Package,
    Truck,
    RefreshCw,
    Droplets,
    Shield,
    CreditCard,
    HelpCircle
} from 'lucide-react';

const FAQCategoryTabs = ({ activeCategory, onCategoryChange, isMobile = false }) => {
    const categories = [
        {
            id: 'all',
            label: 'All Questions',
            icon: HelpCircle,
            count: 45
        },
        {
            id: 'orders',
            label: 'Orders',
            icon: Package,
            count: 12
        },
        {
            id: 'shipping',
            label: 'Shipping & Delivery',
            icon: Truck,
            count: 8
        },
        {
            id: 'returns',
            label: 'Returns & Refunds',
            icon: RefreshCw,
            count: 6
        },
        {
            id: 'products',
            label: 'Product Usage',
            icon: Droplets,
            count: 10
        },
        {
            id: 'ingredients',
            label: 'Ingredients & Safety',
            icon: Shield,
            count: 5
        },
        {
            id: 'payments',
            label: 'Payments',
            icon: CreditCard,
            count: 4
        }
    ];

    return (
        <div className="relative">
            {/* Scrollable container for mobile */}
            <div className={`flex ${isMobile ? 'overflow-x-auto pb-4' : 'flex-wrap'} gap-2`}>
                {categories.map((category, index) => (
                    <motion.button
                        key={category.id}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.05 }}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => onCategoryChange(category.id)}
                        className={`flex items-center gap-2 px-4 py-3 rounded-xl transition-all duration-300 flex-shrink-0 ${
                            activeCategory === category.id
                                ? 'bg-gradient-to-r from-champagne/20 to-sage/20 border border-champagne/30'
                                : 'bg-white border border-nude hover:border-champagne/50'
                        }`}
                    >
                        <category.icon className={`w-4 h-4 ${
                            activeCategory === category.id ? 'text-champagne' : 'text-charcoal/40'
                        }`} />
                        <span className={`font-medium ${
                            activeCategory === category.id ? 'text-charcoal' : 'text-charcoal/70'
                        }`}>
              {category.label}
            </span>
                        <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                            activeCategory === category.id
                                ? 'bg-champagne text-white'
                                : 'bg-nude/30 text-charcoal/50'
                        }`}>
              {category.count}
            </span>
                    </motion.button>
                ))}
            </div>

            {/* Active indicator line */}
            {!isMobile && (
                <motion.div
                    layoutId="category-indicator"
                    className="absolute bottom-0 h-0.5 bg-gradient-to-r from-champagne to-sage rounded-full"
                    style={{
                        width: '120px',
                        left: categories.findIndex(c => c.id === activeCategory) * 140 + 16
                    }}
                />
            )}
        </div>
    );
};

export default FAQCategoryTabs;